import {useQuery} from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetPerformanceAreas = () => {
    const {
        isFetching: isLoading, data: performanceAreas, error,
    } = useQuery({
        queryKey: ["performanceareas"],
        queryFn: () => axiosManager.get$("performanceareas").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const performanceAreasOptions = (performanceAreas || [])
        .toSorted((a, b) => a.displayOrder - b.displayOrder)
        .map((item) => ({value: item.performanceAreaId, label: item.name}));

    return {
        isLoading, performanceAreas, error, performanceAreasOptions,
    };

};
